import { watchRegistration } from './lib/appUpdate'
import { API_CACHE } from './sw/policy'

const UPDATE_CHECK_MS = 30 * 60 * 1000

/**
 * Register the service worker in production builds only (the dev server serves no precache manifest), then look for
 * a newer deploy when the tab comes back into view and every 30 minutes (see lib/appUpdate.ts).
 */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((registration) => {
      watchRegistration(registration)
      const check = () => { registration.update().catch(() => undefined) }
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check() })
      window.setInterval(check, UPDATE_CHECK_MS)
    }).catch(() => undefined)
  })
}

/** On sign-out: empty the API fallback cache (it may hold equipment condition the next user must not see). */
export async function clearApiCache(): Promise<void> {
  try {
    navigator.serviceWorker?.controller?.postMessage({ type: 'clear-api-cache' })
    if ('caches' in globalThis) await caches.delete(API_CACHE.name)
  } catch {
    /* no cache available */
  }
}
